import { getOptionalStringEnv } from './safeEnvParsing';

export const isServerSide = () => typeof window === 'undefined';

export const getIsDev = () => getOptionalStringEnv('NEXT_PUBLIC_IS_DEV');
